<template lang="pug">
.filters-wrapper
  .filters(@click="showFiltersForm()")
    .filters-icon
      inline-svg(:src="require('../../../../assets/icons/filters/more_filters.svg')")
    .filters-text {{ filtersLabel }}
    .reset-filters
  .filters-icons
    inline-svg.reset-filters-icon(
      @click="resetFilters()",
      :src="require('../../../../assets/icons/filters/reset_filters.svg')"
    )
    inline-svg.reset-last-filter-icon(
      v-if="filtersCount > 0",
      @click="resetLastFilter()",
      :src="require('../../../../assets/icons/back.svg')"
    )
  q-dialog(v-model="showForm")
    .dialog-wrapper
      form(
        :uiPath="filtersData.path",
        :method="filtersData.method",
        :header="filtersData.label",
        :initialFields="initialFilters",
        type="filters",
        @close-form="hideFiltersForm()",
        @update-filters="updateFilters"
      )
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import form from "../form/form.vue";
import backend from "@/api";
import { handleError } from "@/services/handleErrors";

const props = defineProps({
  /** Данные о фильтрах. Пример:
  {
    "label": "Все фильтры",
    "method": "get",
    "path": "/api/v3/ui/acts/filters"
  }
  */
  filtersData: { type: Object, default: () => {} },
  /** Текущие фильтры. Нужно для получения дефолтных значений формы фильтров */
  initialFilters: { type: Object, default: () => {} },
});

const emit = defineEmits([
  /** Эмит для обновления фильтров. Принимает объект с параметрами фильтров страницы. Пример: { facility_id: 1, ... } */
  "update-filters",
  /** Эмит удаления последнего фильтра. Не принимает параметры */
  "reset-last-filter",
]);

const loading = ref(false);
const showForm = ref(false);

const filtersData = computed(() => props.filtersData);
const filtersCount = computed(() => Object.keys(props.initialFilters).length);
const filtersLabel = computed(() =>
  filtersCount.value > 0 ? `${filtersData.value.label}(${filtersCount.value})` : filtersData.value.label,
);

const showFiltersForm = () => {
  showForm.value = true;
};

const hideFiltersForm = () => {
  showForm.value = false;
};

const updateFilters = filters => {
  emit("update-filters", filters);
};

const resetFilters = () => {
  emit("update-filters", {});
};

const resetLastFilter = () => {
  emit("reset-last-filter");
};
</script>

<style lang="scss" scoped>
.filters-wrapper {
  display: flex;
  align-items: center;
}

.filters {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  text-decoration: underline;
  color: #5b7aff;
  font-weight: 600;
}

.dialog-wrapper {
  width: 530px;
}
</style>

<style lang="scss">
.filters-wrapper {
  .filters-icons {
    margin-left: 5px;
    display: flex;
    gap: 13px;
    align-items: center;
    .reset-filters-icon {
      cursor: pointer;

      &:hover {
        path {
          fill: #5b7aff;
        }
      }
    }
    .reset-last-filter-icon {
      cursor: pointer;
      width: 17px;
      height: 17px;

      path {
        fill: #3e4958;
      }

      &:hover {
        path {
          fill: #5b7aff;
        }
      }
    }
  }
}
</style>
